(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule', [
            'services.historyCtxt',
            'oddCampaignRespondentModule',
            'oddSurveyQuestionnaireTemplateModule'
        ])
        .constant('CAMPAIGN_TYPES', {
            ODD: 'ODD',
            SURVEY: 'SURVEYV2'
        });
})();
